<app-menu-overlay #menu>
  <div header>
    <div class="crop-details-header">
      {{ 'SCOUTING.DETAILS_CROP.TITLE' | translate }}
      <ng-container *isOffline="false">
        @if (crop().location; as location) {
          <mat-icon
            (click)="openMaps(location)"
            svgIcon="geolocation"
          />
        }
      </ng-container>
    </div>
  </div>
  <div body>
    <div class="crop-details-title">
      {{ 'SCOUTING.DETAILS_CROP.FARM' | translate }}
    </div>
    <div class="crop-details-text">
      {{ crop().farmName }}
      @if (!isOffer()) {
        <bnd-button
          *isOffline="false"
          [routerLink]="['/crop-management/farm', crop().farmId, 'field']"
          mode="ghost"
          shape="square"
          size="sm"
          class="ml-2"
        >
          <i class="pi pi-external-link"></i>
        </bnd-button>
      }
    </div>
    <div class="crop-details-title">
      {{ 'SCOUTING.DETAILS_CROP.FIELD' | translate }}
    </div>
    <div class="crop-details-text">
      {{ crop().fieldName }}
      @if (!isOffer()) {
        <bnd-button
          *isOffline="false"
          [routerLink]="['/crop-management/farm', crop().farmId, 'field']"
          [queryParams]="{ filter: crop().fieldName }"
          mode="ghost"
          shape="square"
          size="sm"
          class="ml-2"
        >
          <i class="pi pi-external-link"></i>
        </bnd-button>
      }
    </div>
    <div class="crop-details-title">
      {{ 'SCOUTING.DETAILS_CROP.FIELDAREA' | translate }}
    </div>
    <div class="crop-details-text">
      {{ crop().fieldArea }}
      {{ crop().fieldAreaUnit | translateConstant: constantService.areaUnit }}
    </div>
    <div class="crop-details-title">
      {{ 'SCOUTING.DETAILS_CROP.VARIETY' | translate }}
    </div>
    <div class="crop-details-text">
      {{ crop().varietyName }}
    </div>
    <div class="crop-details-title">
      {{ 'SCOUTING.DETAILS_CROP.TYPE' | translate }}
    </div>
    <div class="crop-details-text">
      {{ crop().cropType | translateConstant: constantService.croptypes }}
      @if (!isOffer()) {
        <bnd-button
          mode="ghost"
          shape="square"
          size="sm"
          class="ml-2"
          *isOffline="false"
          [routerLink]="['/crop-management/crop']"
          [queryParams]="{ filter: crop().cropType }"
        >
          <i class="pi pi-external-link"></i>
        </bnd-button>
      }
    </div>
    <div class="crop-details-title">
      {{ 'SCOUTING.DETAILS_CROP.PLANTED' | translate }}
    </div>
    <div class="crop-details-text">
      {{ crop().plantedArea }}
      {{ crop().areaUnit | translateConstant: constantService.areaUnit }}
    </div>
    <div class="crop-details-title">
      {{ 'SCOUTING.DETAILS_CROP.DATE' | translate }}
    </div>
    @if (crop().plantedDate) {
      <div class="crop-details-text">
        {{ crop().plantedDate | date: dateFormat() }}
      </div>
    }
    <div class="crop-details-title">
      {{ 'SCOUTING.DETAILS_CROP.TECHNICIAN' | translate }}
    </div>
    <div class="crop-details-text">{{ crop().technicianFirstname }} {{ crop().technicianLastname }}</div>
    @if (!isOffer()) {
      <div class="crop-details-title">
        {{ 'SCOUTING.DETAILS_CROP.PLANTED_ID' | translate }}
      </div>
      @if (crop().planting?.plantingId) {
        <div class="crop-details-text">
          {{ crop().planting?.plantingId }}
        </div>
      }
      <div class="crop-details-title">
        {{ 'SCOUTING.DETAILS_CROP.SEEDING_RATE' | translate }}
      </div>
      @if (crop().planting?.seedingRateUnit && crop().planting?.seedingRate) {
        <div class="crop-details-text">
          {{ crop().planting?.seedingRate }}
          {{ crop().planting?.seedingRateUnit | translateConstant: constantService.seedingRateUnit }}
        </div>
      }
      <div class="crop-details-title">
        {{ 'SCOUTING.DETAILS_CROP.SOIL_CONDITIONS' | translate }}
      </div>
      @if (crop().planting?.soilConditions) {
        <div class="crop-details-text">
          {{ crop().planting?.soilConditions | translateConstant: constantService.soilConditions }}
        </div>
      }
      <div class="crop-details-title">
        {{ 'SCOUTING.DETAILS_CROP.SEED_LINES' | translate }}
      </div>
      @if (crop().planting?.seedLines && crop().planting?.beds && crop().planting?.bedWidth) {
        <div class="crop-details-text">
          {{ crop().planting?.seedLines }} / {{ crop().planting?.beds }} /
          {{ crop().planting?.bedWidth }}
        </div>
      }
      <div class="crop-details-title">
        {{ 'SCOUTING.DETAILS_CROP.WEATHER_CONDITIONS' | translate }}
      </div>
      @if (crop().planting?.weatherConditions) {
        <div class="crop-details-text">
          {{ crop().planting?.weatherConditions | translateConstant: constantService.weatherConditions }}
        </div>
      }
      <div class="crop-details-title">
        {{ 'SCOUTING.DETAILS_CROP.NOTE' | translate }}
      </div>
      @if (crop().notes) {
        <div class="crop-details-text">
          {{ crop().notes }}
        </div>
      }
      <div class="crop-details-title">
        {{ 'SCOUTING.DETAILS_CROP.PLANTING_NOTE' | translate }}
      </div>
      @if (crop().planting?.plantingNote) {
        <div class="crop-details-text">
          {{ crop().planting?.plantingNote }}
        </div>
      }
      <div class="crop-details-title">
        {{ 'SCOUTING.DETAILS_CROP.FORECAST_HARVEST_DATE' | translate }}
      </div>
      @if (crop().forecastHarvestDateAsDate) {
        <div class="crop-details-text">
          {{ crop().forecastHarvestDateAsDate | date: dateFormat() }}
        </div>
      }
    }
  </div>
</app-menu-overlay>
